import * as actionTypes from './actionTypes';
import { ENDPOINT_OPTIONS } from './constants';

export const generateDemoAccountRequest = (email: string, projectName: string) => ({
  type: actionTypes.GENERATE_DEMO_ACCOUNT_REQUEST,
  email,
  projectName,
});

export const uploadEventRequest = (
  apiKey: string,
  body: Record<string, any>,
  endpoint: (typeof ENDPOINT_OPTIONS)[number],
) => ({
  type: actionTypes.UPLOAD_EVENT_REQUEST,
  apiKey,
  body,
  endpoint,
});

export const uploadEventResponse = () => ({
  type: actionTypes.UPLOAD_EVENT_RESPONSE,
});
